import { sliceCropToAspect } from '@ff-os/shared-utils/crop/sliceCropToSize';
import { Area } from '@ff-os/shared-utils/types/Area';
import { Size } from '@ff-os/shared-utils/types/Size';
import { clamp } from 'lodash';

export const rotateAndSliceCrop = (crop: Area, container: Size, newAspectRatio: number) => {

    const newCropWidth = Math.min(container.width, crop.height);
    const newCropHeight = Math.min(container.height, crop.width);
    const newX = crop.x + (0.5 * crop.width) - (0.5 * newCropWidth);
    const newY = crop.y + (0.5 * crop.height) - (0.5 * newCropHeight);

    const clampedX = clamp(newX, 0, container.width - newCropWidth);
    const clampedY = clamp(newY, 0, container.height - newCropHeight);

    const rotatedCrop = {
        width: newCropWidth,
        height: newCropHeight,
        x: clampedX,
        y: clampedY
    };

    return sliceCropToAspect(rotatedCrop, newAspectRatio);
};